import { Pagination } from '../../../models/Pagination';
import { useQuery } from '@tanstack/react-query';
import { GlobalReactQueryOptions } from '../../config';
import { fetchLibraryManagedProductGroupProducts } from './apiFetchLibraryManagedProductGroupProducts';
import { browserClient } from '../../react-query';
import { ProductFilter } from '../../store/api';

const LIBRARY_MANAGED_PRODUCT_GROUPS_QUERY_KEY = 'libraryManagedProductGroupProducts';

export const useLibraryManagedProductGroupProducts = ({
    productGroupId,
    pagination,
    filterMap = {},
    enabled
}: {
    productGroupId: string;
    pagination: Pagination;
    filterMap?: ProductFilter;
    enabled?: boolean;
}) => {
    return useQuery(
        [LIBRARY_MANAGED_PRODUCT_GROUPS_QUERY_KEY, productGroupId, { filterMap, ...pagination }],
        () => fetchLibraryManagedProductGroupProducts(productGroupId, { pagination, filterMap }),
        { ...GlobalReactQueryOptions, enabled }
    );
};

export function invalidateLibraryManagedProductGroupProducts(productGroupId: string) {
    return browserClient.invalidateQueries({ queryKey: [LIBRARY_MANAGED_PRODUCT_GROUPS_QUERY_KEY, productGroupId] });
}
